module.exports = "pegasus_template/assets/themelp1/basic/107.png";